export function decodeIfNeeded(source) {
    return source ? decodeURIComponent(source) : source;
}
export const getPlatformChangeLabel = (label) => `【平台变更】${label}`;
export const I18N_CHANGE_LABEL = getPlatformChangeLabel('多语言');
